import { LoginForm } from './login-form';

export function LoginPage() {
  return (
    <div
      className="flex min-h-dvh items-center justify-center px-4"
      style={{ background: 'var(--color-base)' }}
    >
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-xl font-semibold tracking-tight text-[#ededf0]">CaseTrace</h1>
          <p className="mt-1.5 text-sm text-[#5e6070]">Logg inn for å fortsette</p>
        </div>

        <div
          className="rounded-xl border p-6"
          style={{
            background: 'var(--color-surface)',
            borderColor: 'rgba(255,255,255,0.08)',
          }}
        >
          <LoginForm />
        </div>

        <p className="mt-6 text-center text-xs text-[#3e404e]">
          Har du fått invitasjon? Følg lenken i e-posten for å sette passord første gang.
        </p>
      </div>
    </div>
  );
}
